<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Transaction Log</div>
        <div>
          <bread-crumb :bread-crumbs="['Transaction Log']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-row class="mt-1">
          <v-col cols="12" md="2" lg="2" xs="12">
            <v-text-field
              type="date"
              v-model="from_date"
              :max="maxDate"
              :rules="[validateFromDate]"
              :items="transactionLog"
              placeholder="From"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2" lg="2" xs="12">
            <v-text-field
              type="date"
              placeholder="To"
              v-model="to_date"
              :items="transactionLog"
              :rules="[validateToDate]"
              :max="maxDate"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <div class="d-flex">
            <v-btn depressed 
              small
              class="text-capitalize"
              @click="getTransactionlogdata()"
              color="primary"
              >Get Results</v-btn
            >
          </div>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4" lg="4" xs="12"
            ><v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to search the table data."
              hide-details
              single-line
              class="me-4"
              dense
              clearable
            ></v-text-field
          ></v-col>
        </v-row>
        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :search="search"
          :items="transactionLog"
          loading-text="Please select the criteria to view records."
          no-data-text="Please select the criteria to view records."
          dense
          class="mt-6"
        >
          <!-- <template v-slot:item.actions="{ item }">
            <v-icon small color="primary" class="mr-2" @click="editItem(item)">
              mdi-download
            </v-icon>
          </template> -->
        </v-data-table>
      </v-card-text>
      <OverlayPageVue :showOverlay="loaderOverlay" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import userService from "@/services/UserService/userService.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name: "Transaction Log",
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  data: () => ({
    headers: [
      { text: "Transaction ID", value: "transaction_id" },
      { text: "Pin No", value: "pin_no" },
      { text: "Partner ID", value: "partner_id" },
      { text: "Function Name", value: "function_name" },
      { text: "Date", value: "date" },
      { text: "User", value: "user" },
      { text: "Download", value: "actions", align: "center" },
    ],
    search: "",
    from_date: null,
    to_date: null,
    loaderOverlay: false,
    transactionLog: [],
  }),

  computed: {
    maxDate() {
      // get current date and format as YYYY-MM-DD for use with max attribute
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      return `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;
    },
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    validateFromDate(value) {
      if (value && this.to_date) {
        return (
          value <= this.to_date || "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToDate(value) {
      if (value && this.from_date) {
        return (
          value >= this.from_date || "To date cannot be earlier than From date"
        );
      }
      return true;
    },
    async getTransactionlogdata() {
      this.loaderOverlay = true;
      try {
        const params = {
          from_date: this.from_date,
          to_date: this.to_date,
          skip: 0,
          limit: 50,
        };
        const response = await userService.getTransctionlog(params);
        if (response.status === 200) {
          this.transactionLog = response.data;
          console.log("transactionLog", this.transactionLog);
          this.stoploader();
        } else if (response.status === 401) {
          this.transactionLog = [];
          // this.returnNewToken();
          // this.getTransactionlogdata();
          // this.stoploader();
        } else {
          this.transactionLog == [];
          this.stoploader();
        }
      } catch (error) {
        this.transactionLog = [];
        this.stoploader();
        console.error(error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
</style>
